import React from "react";
import { FaLongArrowAltRight, FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";
import devloperlogoone from "../assets/img/devloper1.svg";
import devloperlogotwo from "../assets/img/devloper2.svg";
import devloperlogothree from "../assets/img/devloper3.svg";
import devloperlogofour from "../assets/img/devloper4.svg";
import devloperlogofive from "../assets/img/devloper5.svg";
import devloperlogosix from "../assets/img/devloper6.svg";
import devloperlogoseven from "../assets/img/devloper7.svg";
import devloperlogoeight from "../assets/img/devloper8.svg";
import devloperlogonine from "../assets/img/devloper9.svg";
import devloperlogoten from "../assets/img/devloper10.svg";
import devloperlogoeleven from "../assets/img/devloper11.svg";
import devloperlogotwelve from "../assets/img/devloper12.svg";
import "swiper/css/bundle";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Autoplay, Navigation } from "swiper/modules";

const PlotBuilderSlider = () => {
  return (
    <>
      {/* developer section auto scroll  */}

      <Swiper
        spaceBetween={10} // Space between slides
        breakpoints={{
          425: {
            slidesPerView: 1, // Show 2 slides on small screens
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3, // Show 4 slides on tablets
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 3, // Show based on content on larger screens
            spaceBetween: 20,
          },
        }}
        modules={[FreeMode, Autoplay, Navigation]}
        navigation={true}
        autoplay={{
          delay: 5000, // Delay between slides in milliseconds (e.g., 3 seconds)
          disableOnInteraction: false, // Allow autoplay to continue even after user interaction
        }}
      >
        <SwiperSlide
          style={{
            padding: "20px",
          }}
        >
          <div className="homepage-dev-main-div">
            <div className="devloper-logo-div">
              <div className="start-div">
                <img src={devloperlogoone} alt="Lodha Devloper Logo" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
              </div>
            </div>
            <div>
              <p className="home-page-devloper-txt">
                Lodha Group is a leading developer known for exceptional
                projects across India. Focused on modern living, it blends
                innovation, luxury, and sustainability. With a reputation for
                excellence, Lodha offers outstanding architecture, thoughtful
                design, and world-class amenities in every project.
              </p>
            </div>
          </div>
          <div className="home-devloper-div-btn">
            <Link to={`projects/Lodha-Group`}>
              View all Projects <FaLongArrowAltRight />
            </Link>
          </div>
        </SwiperSlide>
        <SwiperSlide
          style={{
            padding: "20px",
          }}
        >
          <div className="homepage-dev-main-div">
            <div className="devloper-logo-div">
              <div className="start-div">
                <img src={devloperlogotwo} alt="Godrej Logo" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
              </div>
            </div>
            <div>
              <p className="home-page-devloper-txt">
                Founded in 1897 during India’s Swadeshi movement, Godrej Group
                serves 1.1 billion consumers globally across various sectors.
                With $6 billion in revenue, it drives innovation,
                sustainability, and social impact while promoting inclusion,
                diversity, and its Good & Green strategy.
              </p>
            </div>
          </div>
          <div className="home-devloper-div-btn">
            <Link to={`projects/Godrej-Properties`}>
              View all Projects <FaLongArrowAltRight />
            </Link>
          </div>
        </SwiperSlide>
        <SwiperSlide
          style={{
            padding: "20px",
          }}
        >
          <div className="homepage-dev-main-div">
            <div className="devloper-logo-div">
              <div className="start-div">
                <img
                  src={devloperlogothree}
                  alt="Arihant Superstructures Logo"
                />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
              </div>
            </div>
            <div>
              <p className="home-page-devloper-txt">
                Arihant Superstructures Ltd., led by Ashok Chhajer, excels in
                Mumbai-Navi Mumbai real estate with 14 projects and 9,500 homes
                delivered over 20 years. Known for innovation and
                sustainability, its landmark WORLD VILLAS project redefines
                living while targeting 30% CAGR growth.
              </p>
            </div>
          </div>
          <div className="home-devloper-div-btn">
            <Link to={`projects/Arihant-Superstructures`}>
              View all Projects <FaLongArrowAltRight />
            </Link>
          </div>
        </SwiperSlide>
        <SwiperSlide
          style={{
            padding: "20px",
          }}
        >
          <div className="homepage-dev-main-div">
            <div className="devloper-logo-div">
              <div className="start-div">
                <img src={devloperlogofour} alt="Mahindra Group's Logo" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
              </div>
            </div>
            <div>
              <p className="home-page-devloper-txt">
                Mahindra Group's 'Rise' philosophy drives India's real estate
                and infrastructure growth through Mahindra Residences, Mahindra
                World City, and Origins by Mahindra. These developments focus on
                innovation, sustainability, and excellence, offering world-class
                design and well-planned urban living.
              </p>
            </div>
          </div>
          <div className="home-devloper-div-btn">
            <Link to={`projects/Mahindra-Lifespaces`}>
              View all Projects <FaLongArrowAltRight />
            </Link>
          </div>
        </SwiperSlide>
        <SwiperSlide
          style={{
            padding: "20px",
          }}
        >
          <div className="homepage-dev-main-div">
            <div className="devloper-logo-div">
              <div className="start-div">
                <img src={devloperlogofive} alt="Shapoorji Pallonji Logo" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
              </div>
            </div>
            <div>
              <p className="home-page-devloper-txt">
                Shapoorji Pallonji And Company Private Limited is a global
                organization comprising 15 major companies. It provides
                end-to-end solutions across six business segments: Engineering &
                Construction, Infrastructure, Real Estate, Water, Energy, and
                Financial Services, driven by innovation and dedication.
              </p>
            </div>
          </div>
          <div className="home-devloper-div-btn">
            <Link to={`projects/Shapoorji-Pallonji`}>
              View all Projects <FaLongArrowAltRight />
            </Link>
          </div>
        </SwiperSlide>
        <SwiperSlide
          style={{
            padding: "20px",
          }}
        >
          <div className="homepage-dev-main-div">
            <div className="devloper-logo-div">
              <div className="start-div">
                <img src={devloperlogosix} alt="Kohinoor Group Logo" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
              </div>
            </div>
            <div>
              <p className="home-page-devloper-txt">
                Kohinoor Group has been a prominent leader in Pune's real estate
                sector for 39 years. Founded in 1983 by Chairman & Managing
                Director Mr. Krishnakumar Goyal, it began as a cement trading
                business and evolved into a trusted construction brand.
              </p>
            </div>
          </div>
          <div className="home-devloper-div-btn">
            <Link to={`projects/Kohinoor-Group`}>
              View all Projects <FaLongArrowAltRight />
            </Link>
          </div>
        </SwiperSlide>
        <SwiperSlide
          style={{
            padding: "20px",
          }}
        >
          <div className="homepage-dev-main-div">
            <div className="devloper-logo-div">
              <div className="start-div">
                <img src={devloperlogoseven} alt="Hiranandani Group Logo" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
              </div>
            </div>
            <div>
              <p className="home-page-devloper-txt">
                Hiranandani Group has been one of the most premium real estate
                developer in India with more than 40 years of experience in this
                business. Since its inception in 1978, trust of the people in
                Hiranandani Group has been the foundation for our success and
                their unwavering faith motivates us to serve even more.
              </p>
            </div>
          </div>
          <div className="home-devloper-div-btn">
            <Link to={`projects/Hiranandani`}>
              View all Projects <FaLongArrowAltRight />
            </Link>
          </div>
        </SwiperSlide>
        <SwiperSlide
          style={{
            padding: "20px",
          }}
        >
          <div className="homepage-dev-main-div">
            <div className="devloper-logo-div">
              <div className="start-div">
                <img src={devloperlogoeight} alt="Oberoi Realty Logo" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
              </div>
            </div>
            <div>
              <p className="home-page-devloper-txt">
                For over four decades now, Oberoi Realty has been an insignia of
                trust, transparency, cutting-edge technology and differentiated
                service in the Real Estate sector in Mumbai. Rooted in values,
                our growth and respectability have both been built on adherence
                to our vision, mission and the six pillars we stand on, in all
                we do and deliver.
              </p>
            </div>
          </div>
          <div className="home-devloper-div-btn">
            <Link to={`projects/Oberoi-Realty`}>
              View all Projects <FaLongArrowAltRight />
            </Link>
          </div>
        </SwiperSlide>
        <SwiperSlide
          style={{
            padding: "20px",
          }}
        >
          <div className="homepage-dev-main-div">
            <div className="devloper-logo-div">
              <div className="start-div">
                <img src={devloperlogonine} alt="L&T Realty Logo" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
              </div>
            </div>
            <div>
              <p className="home-page-devloper-txt">
                L&T Realty is committed to innovation and excellence and the
                essence of this is seen in every project that we undertake. Our
                expertise in design and construction along-with the cutting-edge
                technology has enabled us to deliver top of the line
                residential, commercial and retail projects across markets.
              </p>
            </div>
          </div>
          <div className="home-devloper-div-btn">
            <Link to={`projects/L&T-Realty`}>
              View all Projects <FaLongArrowAltRight />
            </Link>
          </div>
        </SwiperSlide>
        <SwiperSlide
          style={{
            padding: "20px",
          }}
        >
          <div className="homepage-dev-main-div">
            <div className="devloper-logo-div">
              <div className="start-div">
                <img src={devloperlogoten} alt="Regency Group Logo" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
              </div>
            </div>
            <div>
              <p className="home-page-devloper-txt">
                Welcome to Regency Group, where every landmark project offers a
                wealth of indulgences. Experience pure bliss with our modern
                amenities, affordable living options, and unparalleled comfort,
                all designed to redefine your lifestyle.
              </p>
            </div>
          </div>
          <div className="home-devloper-div-btn">
            <Link to={`projects/Regency-Group`}>
              View all Projects <FaLongArrowAltRight />
            </Link>
          </div>
        </SwiperSlide>
        <SwiperSlide
          style={{
            padding: "20px",
          }}
        >
          <div className="homepage-dev-main-div">
            <div className="devloper-logo-div">
              <div className="start-div">
                <img src={devloperlogoeleven} alt="Kalpataru Logo" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
              </div>
            </div>
            <div>
              <p className="home-page-devloper-txt">
                Kalpataru Projects International Limited (KPIL) is one of the
                largest Engineering and Construction companies listed in India,
                with a diversified portfolio of projects worldwide, in Power
                Transmission & Distribution (T&D), Buildings & Factories, Water
                Supply & Irrigation, Railways, Oil & Gas Pipelines, Urban
                Mobility (Flyovers & Metro Rail)
              </p>
            </div>
          </div>
          <div className="home-devloper-div-btn">
            <Link to={`projects/Kalpataru`}>
              View all Projects <FaLongArrowAltRight />
            </Link>
          </div>
        </SwiperSlide>
        <SwiperSlide
          style={{
            padding: "20px",
          }}
        >
          <div className="homepage-dev-main-div">
            <div className="devloper-logo-div">
              <div className="start-div">
                <img src={devloperlogotwelve} alt="Rustomjee Logo" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
                <FaStar className="star-icon" />
              </div>
            </div>
            <div>
              <p className="home-page-devloper-txt">
                Established in 1995, Rustomjee has transformed the real estate
                landscape of Mumbai City and has been built on the belief that
                ideas form the cornerstones of buildings. Bricks and mortar are
                merely the blocks that help in realizing them. Ideas transform
                houses into homes and offices into innovation centers
              </p>
            </div>
          </div>
          <div className="home-devloper-div-btn">
            <Link to={`projects/Rustomjee`}>
              View all Projects <FaLongArrowAltRight />
            </Link>
          </div>
        </SwiperSlide>
      </Swiper>

      {/* developer section auto scroll  */}
    </>
  );
};

export default PlotBuilderSlider;
